const OUNCES_TO_GRAMS = 28.3495

export function gramsToOunces(inGrams) {
  return inGrams / OUNCES_TO_GRAMS
}
